import React, { useState, useEffect } from 'react';
import { Button, Typography, IconButton, Tooltip } from "@material-ui/core";
import { faFileImage, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { buildShapperPath } from "../../../helpers/Tools";

function ImageUploader({
                           onImageSelected,
                           defaultValue = null,
                           onImageRemoved = () => {},
                           label = "Image",
                           positionPreview = "above",
                           multiple = false
                       }) {
    const [images, setImages] = useState([]);

    useEffect(() => {
        if (defaultValue) {
            let defaults = multiple ? defaultValue : [defaultValue];
            //explode by ,

            if(typeof defaults === 'string') {
                defaults = defaults.split(',');
            } else if (!Array.isArray(defaults)) {
                defaults = [defaults];
            }

            console.log("defaultsdefaultsdefaults");
            console.log(defaults);

            const imagePaths = defaults.map(path => {
                const trimmedPath = path.trim();
                return trimmedPath ? buildShapperPath(trimmedPath) : null;
            }).filter(Boolean);
            setImages(imagePaths);
            onImageSelected(multiple ? imagePaths : imagePaths[0]);
        }
    }, [defaultValue]);

    const handleChange = (event) => {
        const files = Array.from(event.target.files).filter(file =>
            file.type.startsWith("image/")
        );

        const imageUrls = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file)
        }));

        const newImages = multiple ? [...images, ...imageUrls] : imageUrls;

        console.log("GLEP");
        console.log(newImages);
        console.log(newImages.map((i) => i.preview));

        //soit c'est une url soit c'est un fichier
        setImages(newImages.map(img => img.preview || img));
        onImageSelected(multiple ? files : files[0]);
    };

    const handleRemove = (index) => {
        const newImages = [...images];
        newImages.splice(index, 1);
        setImages(newImages);
        onImageRemoved(index);
    };

    const renderPreviews = () => (

        images.map((img, index) => (
            <div
                key={index}
                style={{ position: 'relative', display: 'inline-block', margin: 8 }}
            >
                <img
                    src={img}
                    alt={`Aperçu ${index}`}
                    style={{
                        width: '150px',
                        height: '150px',
                        borderRadius: 4,
                        objectFit: 'cover',
                        transition: 'transform 0.2s'
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                    onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                />
                <Tooltip title="Supprimer l'image">
                    <IconButton
                        onClick={() => handleRemove(index)}
                        color="secondary"
                        size="small"
                        style={{
                            position: 'absolute',
                            top: 4,
                            right: 4,
                            backgroundColor: 'rgba(255,255,255,0.7)',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </IconButton>
                </Tooltip>
            </div>
        ))
    );

    return (
        <div>
            {images.length > 0 && positionPreview === "above" && (
                <div style={{ marginTop: 16 }}>
                    <Typography variant="subtitle1">Aperçu :</Typography>
                    <div>{renderPreviews()}</div>
                </div>
            )}

            <input
                accept="image/*"
                id="upload-image"
                type="file"
                multiple={multiple}
                style={{ display: 'none' }}
                onChange={handleChange}
            />

            <label htmlFor="upload-image">
                <Button
                    variant="outlined"
                    color="primary"
                    component="span"
                    startIcon={<FontAwesomeIcon icon={faFileImage} />}
                    style={{
                        padding: '10px 20px',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 500,
                        fontSize: '14px',
                        boxShadow: 'none'
                    }}
                >
                    {label || 'Ajouter une image'}
                </Button>
            </label>

            {images.length > 0 && positionPreview === "below" && (
                <div style={{ marginTop: 16 }}>
                    {renderPreviews()}
                </div>
            )}
        </div>
    );
}

export default ImageUploader;
